/* ==========================================================================
   yūgure V3 · Kaki : quiz « Trouver le luminaire fait pour vous ».
   - Données : /collections/all?view=quiz (templates/collection.quiz.liquid), pages de 50, cache de session.
   - Parcours : 7 questions max (hauteur sous plafond seulement si « au plafond », emplacement sauté pour l'extérieur).
   - Algo : filtres stricts pièce + emplacement (assouplis si aucun résultat), puis score
     style ×3, rôle ×2, matière ×2, budget ×2, hauteur ±3, bonus best-seller et avis ; 1 à 3 produits de types variés.
   - Mesure (équivalent Revenue Hunt) : événements Klaviyo « Quiz démarré / réponse / terminé / produit cliqué »
     sur un profil anonyme (anonymous_id), rattaché au profil connu si Klaviyo identifie déjà le visiteur (_kx du cookie
     __kla_id) ou s'il donne son e-mail ; ajout au panier marqué
     propriété de ligne « _quiz » + attribut de panier « _quiz_session » (commandes et CA du quiz dans Shopify).
   Ouverture : tout élément [data-k-qz-ouvrir] (valeur facultative = réponse pré-remplie à la question « pièce »).
   ========================================================================== */
(function () {
  if (window.__kQuiz) return;
  window.__kQuiz = true;
  // bande d'accueil + bouton flottant rendent chacun le dialog : on n'en garde qu'un
  function unSeulDialog() { [].slice.call(document.querySelectorAll('[data-k-qz]'), 1).forEach(function (d) { d.remove(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', unSeulDialog); else unSeulDialog();

  var Q = [
    { id: 'piece', titre: 'Pour quelle pièce ?', options: [
      { v: 'salon', l: 'Salon', rooms: ['Salon'] },
      { v: 'chambre', l: 'Chambre', rooms: ['Chambre'] },
      { v: 'salle-a-manger', l: 'Salle à manger', rooms: ['Salle à Manger'] },
      { v: 'cuisine', l: 'Cuisine', rooms: ['Cuisine'] },
      { v: 'entree', l: 'Entrée ou couloir', rooms: ['Entrée', 'Couloir'] },
      { v: 'salle-de-bain', l: 'Salle de bain', rooms: ['Salle de Bain'] },
      { v: 'exterieur', l: 'Extérieur', rooms: ['Extérieur'] }
    ] },
    { id: 'position', titre: 'Où le voyez-vous ?', si: function (a) { return a.piece !== 'exterieur'; }, options: [
      { v: 'plafond', l: 'Au plafond', d: 'Suspension, plafonnier, lustre' },
      { v: 'mur', l: 'Au mur', d: 'Applique' },
      { v: 'pose', l: 'Posé', d: 'Lampe de table ou lampadaire' },
      { v: 'egal', l: 'Je ne sais pas encore', d: 'Nous choisissons pour vous' }
    ] },
    { id: 'hauteur', titre: 'Quelle hauteur sous plafond ?', si: function (a) { return a.position === 'plafond'; }, options: [
      { v: 'basse', l: 'Basse', d: 'Moins de 2,40 m' },
      { v: 'standard', l: 'Standard', d: 'Autour de 2,50 m' },
      { v: 'haute', l: 'Haute', d: 'Plus de 2,70 m, ou au-dessus d’une table' }
    ] },
    { id: 'role', titre: 'Quel rôle pour cette lumière ?', options: [
      { v: 'principale', l: 'Éclairer toute la pièce', d: 'La lumière principale' },
      { v: 'ambiance', l: 'Créer une ambiance douce', d: 'Le soir, en complément' },
      { v: 'lecture', l: 'Lire ou travailler', d: 'Chevet, bureau, coin lecture' },
      { v: 'ventilo', l: 'Éclairer et rafraîchir', d: 'Plafonnier ventilateur', si: function (a) { return a.position === 'plafond' || a.position === 'egal'; } }
    ] },
    { id: 'style', titre: 'Quel style vous ressemble ?', options: [
      { v: 'epure', l: 'Épuré et moderne', d: 'Lignes nettes, LED, minimalisme' },
      { v: 'naturel', l: 'Naturel et japonais', d: 'Bois, rotin, pierre, wabi-sabi' },
      { v: 'vintage', l: 'Vintage et industriel', d: 'Rétro, métal brut, ampoules apparentes' },
      { v: 'elegant', l: 'Élégant', d: 'Verre, marbre, laiton, doré' }
    ] },
    { id: 'matiere', titre: 'Une matière vous attire ?', options: [
      { v: 'metal', l: 'Métal', m: ['Métal', 'Cuivre', 'Laiton'] },
      { v: 'verre', l: 'Verre', m: ['Verre'] },
      { v: 'bois', l: 'Bois ou rotin', m: ['Bois', 'Tissu / Rotin'] },
      { v: 'pierre', l: 'Marbre ou travertin', m: ['Marbre', 'Pierre / Travertin'] },
      { v: 'egal', l: 'Peu importe', m: [] }
    ] },
    { id: 'budget', titre: 'Quel budget ?', options: [
      { v: 'b1', l: 'Moins de 100 €', min: 0, max: 100 },
      { v: 'b2', l: 'De 100 à 150 €', min: 100, max: 150 },
      { v: 'b3', l: 'De 150 à 250 €', min: 150, max: 250 },
      { v: 'b4', l: 'Plus de 250 €', min: 250, max: 100000 },
      { v: 'egal', l: 'Peu importe' }
    ] }
  ];
  var STYLE = {
    epure: /moderne|minimaliste|lin[ée]aire|design|contemporain|ultra-mince|g[ée]om[ée]trique/,
    naturel: /bois|noyer|ch[êe]ne|rotin|osier|bambou|travertin|pierre|c[ée]ramique|japonais|wabi|nordique|scandinave|papier|lin\b/,
    vintage: /vintage|r[ée]tro|industriel|edison|loft|cage|laiton vieilli/,
    elegant: /verre|marbre|laiton|dor[ée]|luxe|cristal|art d[ée]co|opalin|globe/
  };
  var STYLE_M = { epure: ['Métal'], naturel: ['Bois', 'Tissu / Rotin', 'Pierre / Travertin'], vintage: ['Métal', 'Cuivre'], elegant: ['Verre', 'Marbre', 'Laiton'] };
  var TYPE_LIB = { suspension: 'Suspension', plafonnier: 'Plafonnier', applique: 'Applique', lampe: 'Lampe de table', lampadaire: 'Lampadaire' };
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';

  function opt(qid, v) { var q = Q.filter(function (x) { return x.id === qid; })[0]; return q && q.options.filter(function (o) { return o.v === v; })[0]; }
  function euros(c) { var e = c / 100; return (e % 1 ? e.toFixed(2).replace('.', ',') : String(e)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'; }
  function type(p) {
    if (p.c.indexOf('ventilateurs') > -1) return 'ventilateur';
    if (p.c.indexOf('lustres') > -1) return 'lustre';
    return p.et || (p.c.indexOf('appliques-murales') > -1 ? 'applique' : p.c.indexOf('plafonniers') > -1 ? 'plafonnier' : p.c.indexOf('suspensions') > -1 ? 'suspension' : 'lampe');
  }
  function position(t) { return t === 'applique' ? 'mur' : (t === 'lampe' || t === 'lampadaire') ? 'pose' : 'plafond'; }

  /* ---------- Moteur de recommandation ---------- */
  function noter(p, a) {
    var t = type(p), s = 0, pq = [];
    var titre = (p.t + ' ' + p.o).toLowerCase();
    var piece = opt('piece', a.piece);
    if (piece && p.r.some(function (r) { return piece.rooms.indexOf(r) > -1; })) pq.push(piece.v === 'entree' ? 'Pensé pour l’entrée et le couloir' : piece.v === 'exterieur' ? 'Conçu pour l’extérieur' : 'Pensé pour ' + (/^[aeéiou]/i.test(piece.l) ? 'l’' : piece.v === 'chambre' || piece.v === 'cuisine' || piece.v === 'salle-a-manger' || piece.v === 'salle-de-bain' ? 'la ' : 'le ') + piece.l.toLowerCase());
    if (a.hauteur === 'basse') { if (t === 'plafonnier') { s += 3; pq.push('Plat, idéal sous un plafond bas'); } else if (t === 'suspension' || t === 'lustre') s -= 6; }
    if (a.hauteur === 'haute') { if (t === 'suspension' || t === 'lustre') { s += 2; pq.push('Prend sa place sous un plafond haut'); } else if (t === 'plafonnier') s -= 1; }
    if (a.role === 'principale') { if (t === 'plafonnier' || t === 'lustre') s += 2; else if (t === 'suspension') s += 1; if (p.l >= 40) s += 1; }
    if (a.role === 'ambiance') { if (t === 'applique' || t === 'lampe' || t === 'lampadaire') s += 2; else if (t === 'suspension') s += 1; }
    if (a.role === 'lecture') { if (/chevet|lecture|orientable|bureau|liseuse|flexible/.test(titre)) { s += 3; pq.push('Orientable, pour lire ou travailler'); } if (t === 'lampe' || t === 'applique') s += 1; }
    if (a.role && a.role !== 'ventilo' && /t[ée]l[ée]commande|intensit[ée]|3 temp/.test(titre)) { s += 0.5; }
    if (/3 temp/.test(titre)) pq.push('3 températures de lumière');
    else if (/t[ée]l[ée]commande|intensit[ée] variable/.test(titre)) pq.push('Intensité réglable à distance');
    var st = a.style && STYLE[a.style];
    if (st) {
      // le mot-clé du titre fait le style ; la matière seule ne donne qu'un petit plus, sans être affichée comme raison
      if (st.test(p.t.toLowerCase())) { s += 3; pq.push('Style ' + opt('style', a.style).l.toLowerCase()); }
      else if (p.m.some(function (m) { return STYLE_M[a.style].indexOf(m) > -1; })) s += 1;
    }
    var mat = a.matiere && opt('matiere', a.matiere);
    if (mat && mat.m.length) {
      var mm = p.m.filter(function (m) { return mat.m.indexOf(m) > -1; });
      if (mm.length) { s += 2; pq.push('En ' + mm[0].toLowerCase().replace(' / ', ' et ')); }
    }
    var b = a.budget && opt('budget', a.budget), prix = p.p / 100;
    if (b && b.max) {
      if (prix >= b.min && prix <= b.max) { s += 2; pq.push('Dans votre budget'); }
      else if (prix > b.max) s -= Math.min(6, (prix - b.max) / b.max * 20);
      else s -= Math.min(2, (b.min - prix) / b.min * 5);
    }
    if (p.bs) { s += 1; pq.push('L’un de nos best-sellers'); }
    if (p.rc >= 3 && p.rt >= 4.5) s += 0.5;
    s += Math.min(p.rc, 30) * 0.01;
    // raisons affichées : pièce, style, budget, puis le reste
    var ordre = [/^Pens|^Con/, /^Style/, /budget/, /^En /, /plafond/, /Orientable/, /temp|distance/, /best-seller/];
    pq.sort(function (x, y) {
      var rx = ordre.findIndex(function (re) { return re.test(x); }), ry = ordre.findIndex(function (re) { return re.test(y); });
      return (rx < 0 ? 99 : rx) - (ry < 0 ? 99 : ry);
    });
    return { p: p, s: s, t: t, pourquoi: pq.slice(0, 3) };
  }

  function tableau(x) { return Array.isArray(x) ? x : (x ? String(x).split(/\s*[,|]\s*/) : []); }
  function recommander(P, a) {
    P = P.map(function (p) { p.r = tableau(p.r); p.m = tableau(p.m); p.c = tableau(p.c); p.o = p.o || ''; return p; });
    var piece = opt('piece', a.piece);
    var pos = a.piece === 'exterieur' ? 'egal' : (a.position || 'egal');
    function filtre(niv) {
      return P.filter(function (p) {
        var t = type(p);
        if (a.role === 'ventilo') { if (t !== 'ventilateur' && niv < 1) return false; }
        else if (t === 'ventilateur') return false;
        if (niv < 1 && pos !== 'egal' && position(t) !== pos) return false;
        if (niv < 2 && piece && !p.r.some(function (r) { return piece.rooms.indexOf(r) > -1; })) return false;
        if (a.piece !== 'exterieur' && p.c.indexOf('luminaires-exterieur') > -1 && niv < 2) return false;
        return true;
      });
    }
    var niv = 0, c = filtre(0);
    while (!c.length && niv < 2) c = filtre(++niv);
    if (!c.length) c = P.slice();
    var notes = c.map(function (p) { return noter(p, a); }).sort(function (x, y) { return y.s - x.s; });
    var pris = [notes[0]];
    for (var i = 1; i < notes.length && pris.length < 3; i++) {
      var n = notes[i];
      if (n.s < notes[0].s - 6) break;
      var memeType = pris.some(function (x) { return x.t === n.t; });
      var memeNom = pris.some(function (x) { return x.p.jp && x.p.jp === n.p.jp; });
      if (!memeType && !memeNom) pris.push(n);
    }
    for (var j = 1; j < notes.length && pris.length < 3; j++) {
      if (pris.indexOf(notes[j]) === -1 && notes[j].s >= notes[0].s - 6) pris.push(notes[j]);
    }
    pris.sort(function (x, y) { return y.s - x.s; });
    return { liste: pris, assoupli: niv };
  }
  window.kakiQuizRecommander = recommander; // exposé pour les tests

  /* ---------- Données ---------- */
  var donnees = null;
  function charger() {
    if (donnees) return donnees;
    try { var c = JSON.parse(sessionStorage.getItem('k-qz-data') || 'null'); if (c && Date.now() - c.t < 1800000) return (donnees = Promise.resolve(c.d)); } catch (e) {}
    var tous = [];
    function page(n) {
      return fetch('/collections/all?view=quiz&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { tous = tous.concat(d.produits || []); return n < d.pages ? page(n + 1) : tous; });
    }
    donnees = page(1).then(function (d) { try { sessionStorage.setItem('k-qz-data', JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} return d; });
    donnees.catch(function () { donnees = null; });
    return donnees;
  }

  /* ---------- Mesure ---------- */
  var cfg = window.kakiQuizConfig || {};
  function anonId() {
    var k = 'k-qz-anon', v;
    try { v = localStorage.getItem(k); } catch (e) {}
    if (!v) { v = 'qz-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); try { localStorage.setItem(k, v); } catch (e) {} }
    return v;
  }
  var email = '';
  // Visiteur déjà connu de Klaviyo (clic dans un mail, pop-up…) : identifiant d'échange du cookie __kla_id.
  // Envoyé avec l'anonymous_id, il rattache le quiz à son vrai profil, donc à ses commandes dans Klaviyo.
  function klaviyoKx() {
    try {
      var c = document.cookie.split('; ').filter(function (x) { return x.indexOf('__kla_id=') === 0; })[0];
      if (!c) return '';
      var d = JSON.parse(atob(decodeURIComponent(c.slice(9))));
      return d.$exchange_id || '';
    } catch (e) { return ''; }
  }
  function suivre(nom, props) {
    props = props || {};
    if (window.dataLayer) window.dataLayer.push({ event: 'quiz_' + nom.toLowerCase().replace(/\s+/g, '_').normalize('NFD').replace(/[̀-ͯ]/g, ''), quiz: props });
    if (!cfg.klaviyo) return;
    var prof = { anonymous_id: anonId() };
    var kx = klaviyoKx();
    if (kx) prof._kx = kx;
    if (email) prof.email = email;
    function envoyer(pr) {
      return fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(cfg.klaviyo), {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-01-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props, metric: { data: { type: 'metric', attributes: { name: nom } } },
          profile: { data: { type: 'profile', attributes: pr } } } } })
      });
    }
    // _kx refusé (« Invalid exchange id ») : on renvoie sans, pour ne jamais perdre l'événement
    envoyer(prof).then(function (r) {
      if (r.status === 400 && prof._kx) { delete prof._kx; return envoyer(prof); }
    }).catch(function () {});
  }

  /* ---------- Interface ---------- */
  var dlg, corps, barre, compteur, retour, etat;
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function etapes() { return Q.filter(function (q) { return !q.si || q.si(etat.a); }); }

  function ouvrir(pre, source) {
    dlg = document.querySelector('[data-k-qz]');
    if (!dlg) return;
    corps = dlg.querySelector('[data-k-qz-corps]');
    barre = dlg.querySelector('[data-k-qz-barre]');
    compteur = dlg.querySelector('[data-k-qz-compteur]');
    retour = dlg.querySelector('[data-k-qz-retour]');
    etat = { a: {}, i: 0, session: 's-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7), source: source || 'accueil' };
    charger();
    if (!dlg.open) dlg.showModal();
    document.documentElement.classList.add('k-qz-ouvert');
    suivre('Quiz démarré', { session: etat.session, source: etat.source });
    if (pre && opt('piece', pre)) repondre('piece', pre, true);
    else afficher();
  }

  function fermer() {
    if (dlg && dlg.open) dlg.close();
    document.documentElement.classList.remove('k-qz-ouvert');
  }

  function afficher() {
    var E = etapes(), q = E[etat.i];
    dlg.classList.remove('is-resultats');
    barre.innerHTML = '';
    for (var k = 0; k < E.length; k++) barre.appendChild(el('span', k < etat.i ? 'is-fait' : k === etat.i ? 'is-ici' : ''));
    compteur.textContent = 'Question ' + (etat.i + 1) + ' sur ' + E.length;
    retour.hidden = etat.i === 0;
    var opts = q.options.filter(function (o) { return !o.si || o.si(etat.a); });
    var sec = el('div', 'k-qz__etape');
    sec.appendChild(el('h2', 'k-qz__q', esc(q.titre)));
    var g = el('div', 'k-qz__options' + (opts.length > 4 ? ' is-nombreuses' : ''));
    g.setAttribute('role', 'radiogroup');
    g.setAttribute('aria-label', q.titre);
    opts.forEach(function (o, n) {
      var b = el('button', 'k-qz__opt' + (etat.a[q.id] === o.v ? ' is-choisie' : ''));
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', etat.a[q.id] === o.v ? 'true' : 'false');
      b.innerHTML = '<span class="k-qz__opt-n k-num" aria-hidden="true">' + String.fromCharCode(65 + n) + '</span>' +
        '<span class="k-qz__opt-l">' + esc(o.l) + '</span>' + (o.d ? '<span class="k-qz__opt-d">' + esc(o.d) + '</span>' : '');
      b.addEventListener('click', function () { repondre(q.id, o.v); });
      g.appendChild(b);
    });
    sec.appendChild(g);
    corps.innerHTML = '';
    corps.appendChild(sec);
    corps.scrollTop = 0;
    var f = g.querySelector('.is-choisie') || g.querySelector('button');
    if (f) f.focus({ preventScroll: true });
  }

  function repondre(qid, v, silencieux) {
    etat.a[qid] = v;
    // une réponse qui change le parcours efface les réponses des questions devenues hors parcours
    if (qid === 'piece' && v === 'exterieur') { delete etat.a.position; delete etat.a.hauteur; }
    if (qid === 'position' && v !== 'plafond') delete etat.a.hauteur;
    if (qid === 'position' && v !== 'plafond' && v !== 'egal' && etat.a.role === 'ventilo') delete etat.a.role;
    var E = etapes(), idx = E.map(function (x) { return x.id; }).indexOf(qid);
    suivre('Quiz réponse', { session: etat.session, etape: idx + 1, question: qid, reponse: v, reponse_libelle: opt(qid, v).l, pre_rempli: !!silencieux });
    etat.i = idx + 1;
    if (etat.i >= E.length) return resultats();
    afficher();
  }

  function resultats() {
    barre.querySelectorAll('span').forEach(function (s) { s.className = 'is-fait'; });
    compteur.textContent = 'Votre sélection';
    dlg.classList.add('is-resultats');
    retour.hidden = false;
    corps.innerHTML = '<div class="k-qz__charge" role="status"><span></span>Nous choisissons pour vous…</div>';
    charger().then(function (P) {
      var r = recommander(P, etat.a);
      suivre('Quiz terminé', { session: etat.session, source: etat.source, reponses: etat.a,
        produits: r.liste.map(function (x) { return x.p.t; }), produits_ids: r.liste.map(function (x) { return x.p.id; }),
        nb_resultats: r.liste.length, assoupli: r.assoupli });
      try { localStorage.setItem('k-qz-fini', String(Date.now())); } catch (e) {}
      document.querySelectorAll('.k-qzf').forEach(function (b) { b.hidden = true; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _quiz_session: etat.session } }) }).catch(function () {});
      rendre(r);
    }).catch(function () {
      corps.innerHTML = '<div class="k-qz__erreur"><p class="k-h3">Le catalogue n’a pas pu être chargé.</p><p>Vérifiez votre connexion puis réessayez, ou parcourez nos luminaires par pièce.</p>' +
        '<div class="k-qz__actions"><button type="button" class="k-btn k-btn--primary" data-k-qz-reessayer>Réessayer</button><a class="k-btn k-btn--ghost" href="/collections/all">Voir tous les luminaires</a></div></div>';
      corps.querySelector('[data-k-qz-reessayer]').addEventListener('click', resultats);
    });
  }

  function rendre(r) {
    var w = el('div', 'k-qz__res');
    var tete = el('div', 'k-qz__res-tete');
    tete.appendChild(el('h2', 'k-qz__q', r.liste.length > 1 ? 'Nos ' + r.liste.length + ' choix pour vous.' : 'Notre choix pour vous.'));
    var recap = el('p', 'k-qz__recap');
    recap.textContent = etapes().map(function (q) { var o = opt(q.id, etat.a[q.id]); return o && o.v !== 'egal' ? o.l : null; }).filter(Boolean).join(' · ');
    tete.appendChild(recap);
    if (r.assoupli) tete.appendChild(el('p', 'k-qz__note', 'Aucun luminaire ne cochait toutes vos réponses : voici les plus proches.'));
    w.appendChild(tete);
    var grille = el('div', 'k-qz__produits k-qz__produits--' + r.liste.length);
    r.liste.forEach(function (x, rang) {
      var p = x.p;
      var c = el('article', 'k-qz__carte' + (rang === 0 ? ' is-premier' : ''));
      c.innerHTML =
        (rang === 0 && r.liste.length > 1 ? '<p class="k-qz__badge">Le plus adapté</p>' : '') +
        '<a class="k-qz__img" href="' + esc(p.u) + '" data-k-qz-fiche>' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy" width="480" height="480">' : '') + '</a>' +
        '<div class="k-qz__infos">' +
          '<p class="k-qz__nom">' + esc(p.jp || p.t) + '</p>' +
          (p.jp ? '<p class="k-qz__titre">' + esc(p.t) + '</p>' : '') +
          '<p class="k-qz__prix k-num">' + (p.nv > 1 ? 'Dès ' : '') + euros(p.p) + '</p>' +
          '<ul class="k-qz__pourquoi">' + x.pourquoi.map(function (t) { return '<li>' + CHECK + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul>' +
          (p.nv > 1 ? '<p class="k-qz__var">Version de base, autres finitions sur la fiche.</p>' : '') +
          '<div class="k-qz__actions">' +
            '<button type="button" class="k-btn k-btn--primary" data-k-qz-ajout data-variant="' + p.v + '"><span data-k-add-label>Ajouter au panier</span></button>' +
            '<a class="k-btn k-btn--ghost" href="' + esc(p.u) + '" data-k-qz-fiche>Voir la fiche</a>' +
          '</div>' +
        '</div>';
      c.querySelectorAll('[data-k-qz-fiche]').forEach(function (a) {
        a.addEventListener('click', function () { suivre('Quiz produit cliqué', { session: etat.session, produit: p.t, produit_id: p.id, rang: rang + 1, action: 'fiche' }); });
      });
      var btn = c.querySelector('[data-k-qz-ajout]');
      btn.addEventListener('click', function () { ajouter(btn, p, rang); });
      grille.appendChild(c);
    });
    w.appendChild(grille);
    if (cfg.liste) w.appendChild(formulaireEmail(r));
    var pied = el('div', 'k-qz__pied');
    pied.innerHTML = '<button type="button" class="k-qz__lien" data-k-qz-refaire>Refaire le quiz</button><a class="k-qz__lien" href="/collections/all">Voir tous les luminaires</a>';
    pied.querySelector('[data-k-qz-refaire]').addEventListener('click', function () { etat.a = {}; etat.i = 0; afficher(); });
    w.appendChild(pied);
    corps.innerHTML = '';
    corps.appendChild(w);
    corps.scrollTop = 0;
    var h = w.querySelector('h2'); h.tabIndex = -1; h.focus({ preventScroll: true });
  }

  function ajouter(btn, p, rang) {
    var lab = btn.querySelector('[data-k-add-label]');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); lab.textContent = 'Ajout…';
    var fin = function (ok, msg) {
      btn.disabled = false; btn.removeAttribute('aria-busy');
      lab.textContent = ok ? 'Ajouté au panier' : (msg || 'Ajout impossible');
      if (ok) {
        suivre('Quiz produit cliqué', { session: etat.session, produit: p.t, produit_id: p.id, rang: rang + 1, action: 'panier' });
        if (!btn.parentNode.querySelector('.k-qz__panier')) { var a = el('a', 'k-qz__lien k-qz__panier', 'Voir le panier'); a.href = '/cart'; btn.parentNode.appendChild(a); }
      }
      setTimeout(function () { lab.textContent = 'Ajouter au panier'; }, 2400);
    };
    var props = { _quiz: etat.session };
    if (window.kakiAdd) window.kakiAdd(btn, p.v, 1, props).then(function (r) { fin(r.ok, r.message); });
    else fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: p.v, quantity: 1, properties: props }] }) })
      .then(function (r) { fin(r.ok); }).catch(function () { fin(false); });
  }

  function formulaireEmail(r) {
    var f = el('form', 'k-qz__email');
    f.noValidate = true;
    // Texte honnête tant qu'aucun flow Klaviyo n'envoie la sélection : réglable via kakiQuizConfig.emailTitre / emailTexte
    f.innerHTML = '<div class="k-qz__email-txt"><p class="k-qz__email-t">' + esc(cfg.emailTitre || '-10 % sur votre première commande') + '</p><p>' + esc(cfg.emailTexte || 'Laissez votre e-mail : votre code de bienvenue arrive tout de suite, avec nos conseils lumière.') + '</p></div>' +
      '<div class="k-qz__email-champ"><label class="visually-hidden" for="k-qz-mail">Votre e-mail</label>' +
      '<input id="k-qz-mail" type="email" name="email" autocomplete="email" placeholder="Votre e-mail" required>' +
      '<button type="submit" class="k-btn k-btn--primary">Recevoir mon code</button></div>' +
      '<p class="k-qz__email-mention">En validant, vous acceptez de recevoir nos e-mails. Désinscription en un clic.</p>' +
      '<p class="k-qz__email-msg" role="status" hidden></p>';
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = f.querySelector('input'), msg = f.querySelector('.k-qz__email-msg');
      if (!inp.checkValidity()) { inp.setAttribute('aria-invalid', 'true'); msg.hidden = false; msg.textContent = 'Cette adresse e-mail ne semble pas valide.'; inp.focus(); return; }
      inp.removeAttribute('aria-invalid');
      email = inp.value.trim();
      var props = { quiz_piece: etat.a.piece || '', quiz_style: etat.a.style || '', quiz_budget: etat.a.budget || '', quiz_produits: r.liste.map(function (x) { return x.p.t; }).join(' | ') };
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.klaviyo), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-01-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Quiz luminaire',
          profile: { data: { type: 'profile', attributes: { email: email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: cfg.liste } } } } })
      }).then(function (res) {
        if (!res.ok) throw new Error(res.status);
        // rattache le parcours anonyme à l'e-mail et déclenche le flow « Quiz terminé »
        suivre('Quiz e-mail', { session: etat.session, reponses: etat.a, produits: r.liste.map(function (x) { return x.p.t; }),
          produits_urls: r.liste.map(function (x) { return location.origin + x.p.u; }), produits_images: r.liste.map(function (x) { return x.p.img ? 'https:' + x.p.img.replace(/^https?:/, '') : ''; }) });
        f.innerHTML = '<p class="k-qz__email-ok">' + CHECK + '<span>' + esc(cfg.emailMerci || 'C’est envoyé : votre code de -10 % arrive dans votre boîte de réception.') + '</span></p>';
      }).catch(function () { msg.hidden = false; msg.textContent = 'L’envoi n’a pas abouti, réessayez dans un instant.'; });
    });
    return f;
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-k-qz-ouvrir]');
    if (o) { e.preventDefault(); ouvrir(o.getAttribute('data-k-qz-ouvrir'), o.getAttribute('data-k-qz-source')); return; }
    if (!dlg) return;
    if (e.target.closest('[data-k-qz-fermer]')) { fermer(); return; }
    if (e.target.closest('[data-k-qz-retour]')) {
      if (etat.i > 0) { etat.i = Math.min(etat.i, etapes().length) - 1; afficher(); }
      return;
    }
    if (e.target === dlg) fermer();
  });
  document.addEventListener('keydown', function (e) {
    if (!dlg || !dlg.open) return;
    if (e.key === 'Escape') { document.documentElement.classList.remove('k-qz-ouvert'); return; }
    var opts = corps && corps.querySelectorAll('.k-qz__opt');
    if (!opts || !opts.length) return;
    var i = [].indexOf.call(opts, document.activeElement);
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); opts[(i + 1) % opts.length].focus(); }
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); opts[(i - 1 + opts.length) % opts.length].focus(); }
    var n = e.key.length === 1 ? e.key.toUpperCase().charCodeAt(0) - 65 : -1;
    if (n >= 0 && n < opts.length && !e.metaKey && !e.ctrlKey && document.activeElement.tagName !== 'INPUT') opts[n].click();
  });
  document.addEventListener('close', function (e) { if (e.target && e.target.matches && e.target.matches('[data-k-qz]')) document.documentElement.classList.remove('k-qz-ouvert'); }, true);
})();
